import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import { Route, Routes as Switch } from "react-router-dom";

import Dashboard from "../views/dashboard";

import Spinner from "../layout/spinner";
import { loginRedirectUrl } from "../utils/auth/navigation";

class Routes extends React.Component {
  componentDidUpdate(oldProps) {

  }
  
  render() {
    const hasSession = Boolean(this.props.auth.token || localStorage.token);

    if (this.props.auth.loading && hasSession && this.props.auth.authenticated !== true) {
      return <Spinner />;
    }

    if (!this.props.auth.authenticated) {
      const loginUrl = loginRedirectUrl(window.location.href);
      window.location.replace(loginUrl);
      return null;
    }
  
    return (
      <>
        <Switch>
          <Route exact={false} path="/*" element={<Dashboard />}></Route>
        </Switch>
      </>
    );

  }

}

Dashboard.propTypes = {
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return ({
        auth: state.auth
    });
};

export default connect(mapStateToProps)(Routes);
